import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { Redirect } from 'react-router-dom';

import { updateMeta } from 'Store/Meta/Meta.action';

export const BreadcrumbsDispatcher = import(
    /* webpackMode: "lazy", webpackChunkName: "dispatchers" */
    'Store/Breadcrumbs/Breadcrumbs.dispatcher'
);

export const mapDispatchToProps = (dispatch) => ({
    updateBreadcrumbs: (breadcrumbs) => BreadcrumbsDispatcher.then(
        ({ default: dispatcher }) => dispatcher.update(breadcrumbs, dispatch)
    ),
    updateMeta: (meta) => dispatch(updateMeta(meta)),
});

export class LbxWrapperContainer extends Component {
    static propTypes = {
        updateBreadcrumbs: PropTypes.func.isRequired,
        updateMeta: PropTypes.func.isRequired,
        location: PropTypes.shape({
            search: PropTypes.string,
        }).isRequired,
    }

    componentDidMount() {
        this.updateBreadcrumbsAndMeta();
    }

    componentDidUpdate(prevProps) {
        const { location } = this.props;
        const { location: prevLocation } = prevProps;

        if (location.search !== prevLocation.search) {
            this.updateBreadcrumbsAndMeta();
        }
    }

    updateBreadcrumbsAndMeta() {
        const { updateBreadcrumbs } = this.props;
        const q = this._extractSearch();

        if (q && q.trim() !== '') {

            const breadcrumbs = [];
            breadcrumbs.push({
                name: `${__('Search')}: '${q}'`,
                url: false
            });

            updateBreadcrumbs(breadcrumbs);

            updateMeta({
                description: `${__('Search results for phrase')}: '${q}'`,
                canonical_url: window.location.href
            });
        }
    }

    _extractSearch() {
        const { location: { search = { search: '' } } } = this.props || {};
        const query = new URLSearchParams(search);

        return query.get('q');
    }

    render() {
        const q = this._extractSearch();

        if (q && q.trim() !== '') {
            return (
                <div className="ContentWrapper">
                    <div id="lbx-search-results"></div>
                </div>
            );
        } else {
            return <Redirect to="/404" />;
        }
    }
}

export default withRouter(connect(null, mapDispatchToProps)(LbxWrapperContainer));
